module.exports = __webpack_public_path__ + "img/location-light.42a7095b.svg";